import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Modal } from "semantic-ui-react";

const CommonConfirmModal = ({
  size = "tiny",
  modalOpen,
  setModalOpen,
  onConfirm,
  onClose = () => {},
  modalProps = {
    title: "",
    content: <p></p>,
    cancelButtonText: "No",
    okButtonText: "Yes",
    buttonLoading: false,
  },
}) => {
  const { title, content, cancelButtonText, okButtonText, buttonLoading } =
    modalProps;
  return (
    <Modal
      className="dark:!bg-base-light-dark !bg-base-light-white"
      size={size}
      open={modalOpen}
      closeOnDimmerClick={false}
      onClose={() => {
        if (typeof setModalOpen === "function") {
          setModalOpen(false);
        }
        onClose();
      }}
    >
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>{content}</Modal.Content>
      <Modal.Actions>
        <Button
          type="button"
          className="bg-white text-black"
          onClick={() => {
            if (typeof setModalOpen === "function") {
              setModalOpen(false);
            }
            onClose();
          }}
          loading={buttonLoading}
          disabled={buttonLoading}
        >
          {cancelButtonText}
        </Button>
        <Button
          positive
          type="button"
          className="!bg-main-color"
          loading={buttonLoading}
          disabled={buttonLoading}
          onClick={(e) => {
            onConfirm(e);
          }}
        >
          {okButtonText}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default CommonConfirmModal;
